module.exports = __webpack_public_path__ + "img/banner-4.321c6e77.jpg";